// ETCswap V1 was never deployed - this file provides stubs for compatibility
import { Trade } from '@etcswapv2/sdk-legacy'

// Re-export Version from useToggledVersion for consistency
export { Version } from '../hooks/useToggledVersion'
import { Version } from '../hooks/useToggledVersion'

// Always returns V2 since V1 doesn't exist
export function getTradeVersion(_trade?: Trade): Version {
  return Version.v2
}

// Always returns false since V1 was never deployed
export function isTradeBetter(
  _tradeA?: Trade,
  _tradeB?: Trade,
  _minimumDelta?: unknown
): boolean {
  return false
}

// V1 hooks - return undefined/false since V1 was never deployed
export function useV1Trade(): Trade | undefined {
  return undefined
}

export function useUserHasLiquidityInAllTokens(): boolean {
  return false
}

export function useV1TradeExchangeAddress(_trade?: Trade): string | undefined {
  return undefined
}
